import React from 'react'
import { Loading } from 'components'
import Provider from './Provider'
import useStyles from './Styles'
import { ISessionManagerProviderViewProps } from './Interfaces'

const SessionManagerView: React.FC<ISessionManagerProviderViewProps> = ({ state, children }) => {
  const classes = useStyles({})

  return state.isLoadingCurrentUser || !state.isMounted ? (
    <div className={classes.root}>
      <Loading />
    </div>
  ) : (
    <React.Fragment>{children}</React.Fragment>
  )
}

export default (props: any) => (
  <Provider>
    {(viewProps: ISessionManagerProviderViewProps) => <SessionManagerView {...viewProps} {...props} />}
  </Provider>
)
